<div class="toast-notification-container">
  <div *ngIf="toast1" class="toast-notification">
    <div class="toast-title" [style]="getStyle() ? 'color: black' : ''">
      <app-texts
        [texts]="[
                {text: ['Куки', 'Cookies']}
              ]"
      />
    </div>
    <div class="toast-content">
      <p [style]="getStyle() ? 'color: black' : ''">
        <app-texts
          [texts]="[
                {text: ['Помогают нам улучшать  пользовательский опыт', 'Cookies help us optimize your user experience']}
              ]"
        />
      </p>
      <div class="toast-content-button" (click)="hideToast1()" [style]="getStyle() ? 'color: black' : ''">
        <app-texts
          [texts]="[
                {text: ['Хорошо', 'Okay']}
              ]"
        />
      </div>
    </div>
  </div>
  <div *ngIf="toast2" class="toast-notification-parent">
    <div class="toast-notification">
      <div class="toast-title" (click)="activeLanguageMenu()">
        <span [style]="getStyle() ? 'color: black' : ''">
          <app-texts
            [texts]="[
                {text: ['Сменить язык', 'Change Language']}
              ]"
          />
        </span>
<!--        <app-icon-->
<!--          class="toast-title-button"-->
<!--          [icon]="getStyle() ? Icons.arrowDownBlack : Icons.arrowDown"-->
<!--          [style.rotate]="languageMenu ? '180deg' : '0deg'"-->
<!--        />-->
      </div>
      <div class="toast-content">
        <p [style]="getStyle() ? 'color: black' : ''">
          <app-texts
            [texts]="[
                {text: ['Выберите предпочтительный язык', 'Select your language preference']}
              ]"
          />
        </p>
        <div class="toast-content-button" (click)="toast2 = false" [style]="getStyle() ? 'color: black' : ''">
          <app-texts
            [texts]="[
                {text: ['Продолжить', 'Continue']}
              ]"
          />
        </div>
      </div>
    </div>
    <div *ngIf="languageMenu"  class="toast-changer-container">
      <div (click)="setLang(0)" class="toast-changer-child">
        <h6 [style]="getStyle() ? 'color: black' : ''">
          <app-texts
            [texts]="[
                {text: ['Русский', 'Russian']}
              ]"
          />
        </h6>
        <app-icon *ngIf="localizationService.getActiveLang() == 0" [icon]="Icons.check" [invert]="getStyle()"/>
      </div>
      <div (click)="setLang(1)" class="toast-changer-child">
        <h6 [style]="getStyle() ? 'color: black' : ''">
          <app-texts
            [texts]="[
                {text: ['Английский', 'English']}
              ]"
          />
        </h6>
        <app-icon *ngIf="localizationService.getActiveLang() == 1"  [icon]="Icons.check" [invert]="getStyle()"/>
      </div>
    </div>
  </div>
  <div *ngIf="notification.getNotifications().length > 0">
    <div *ngFor="let item of notification.getNotifications()"
         class="toast-notification"
         style="min-height: auto"
    >
      <div class="toast-title" [style]="getSystemStyle(item.style)">
        <app-texts
          [texts]="[
                {text: [item.title, item.title]}
              ]"
        />
      </div>
      <div class="toast-content" style="font-size: 14px;">
        <p [style]="getStyle() ? 'color: black' : ''">
          <app-texts
            [texts]="[
                {text: [item.text, item.text]}
              ]"
          />
        </p>
      </div>
    </div>
  </div>
</div>
